// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

export default function Typography() {
    return {
        MuiTypography: {
            styleOverrides: {
                root: {
                    margin: 0
                },
                gutterBottom: {
                    marginBottom: 12
                }
            }
        }
    };
}
